// extracted by mini-css-extract-plugin
export var addressFields = "_pm-0";
export var animationContainer = "_pm-1";
export var footer = "_pm-2";
export var lineItems = "_pm-3";
export var modalContent = "_pm-4";
export var orderName = "_pm-5";
export var strong = "_pm-6";
export var warning = "_pm-7";